<template>
  <div class="reasons-table-wrapper">
    <table class="reasons-table">
      <thead>
        <tr>
          <th>{{ $t('API_ERRORS_REPORT.CHART.ERROR') }}</th>
          <th>{{ $t('API_ERRORS_REPORT.CHART.TOTAL_LABELS') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in topErrors"
          :key="index"
          :class="{ odd: index % 2 !== 0 }"
        >
          <td>{{ item.error }}</td>
          <td>{{ item.count }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ApiErrorsReasonsTable',
  props: {
    apiErrors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    topErrors() {
      const map = {};
      this.apiErrors.forEach(error => {
        const message = error.error;
        if (!message) return;
        map[message] = (map[message] || 0) + 1;
      });
      return Object.entries(map)
        .map(([error, count]) => ({ error, count }))
        .sort((a, b) => b.count - a.count);
    },
  },
};
</script>

<style scoped>
.reasons-table-wrapper {
  max-height: 380px;
  overflow-y: auto;
}

.reasons-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.reasons-table th,
.reasons-table td {
  padding: 8px;
  border: 1px solid #ccc;
  text-align: left;
  vertical-align: top;
}

.reasons-table th {
  background-color: #f0f0f0;
}

.reasons-table tr.odd {
  background-color: #f9f9f9;
}
</style>
